import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

import mutations from './mutations';
import actions from './actions';
import getters from './getters';

import preseditor  from './preseditor';
import socket  from './socket';
import features  from './features';

const state = {
	// Notices
    errors: [],
    notices: [],
    devmode: false,

    // Datas
    channel: false,
    channels: false,
    user: {},
    edituser: false,

    // statussen
    debug: false,
    slimnavigation: false,
    loading: {},
	saveing: false,
	editing: false,
	changed: false,

	mouseposition: {x:0,y:0},

};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
    	preseditor,
    	socket,
    	features
   	},
    // plugins: [createPersistedState({paths: ['channel', 'channels']})]
});



// WEBPACK FOOTER //
// ./src/store/index.js